var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-channel-image"},[(!_vm.unitData.list)?_c('p'):_vm._e(),_vm._l((_vm.unitData.list),function(item,i){return _c('a',{key:i},[_c('sub-image',{staticClass:"item",attrs:{"src":item.img_url,"mode":"aspectFill"}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }